import { render, staticRenderFns } from "./portApprove.vue?vue&type=template&id=7bf668dc&scoped=true&"
import script from "./portApprove.vue?vue&type=script&lang=js&"
export * from "./portApprove.vue?vue&type=script&lang=js&"
import style0 from "./portApprove.vue?vue&type=style&index=0&id=7bf668dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf668dc",
  null
  
)

export default component.exports